module.exports = __webpack_public_path__ + "static/image/reporter-p1.svg?fef84a3f022f64a7c46893362c1ad241";